/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aqua_Spry_Buzzard_TwirlInputs */

const fr_aqua_spry_buzzard_twirl = /** @type {(inputs: Aqua_Spry_Buzzard_TwirlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nouveau mot de passe`)
};

/**

* @param {Aqua_Spry_Buzzard_TwirlInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const aqua_spry_buzzard_twirl = /** @type {((inputs?: Aqua_Spry_Buzzard_TwirlInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aqua_Spry_Buzzard_TwirlInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_aqua_spry_buzzard_twirl(inputs)
});